import StarIcon from '@mui/icons-material/Star';
import donU from "../../assets/images/lead-capture/don-u.png"
import davidD from "../../assets/images/lead-capture/david-d.png";
import lucasM from "../../assets/images/lead-capture/lucas-m.png";
import jimmyM from "../../assets/images/lead-capture/jimmy-m.png";
import mikeE from "../../assets/images/lead-capture/mike-e.png";
import jeffL from "../../assets/images/lead-capture/jeff-l.png";
import cynthiaF from "../../assets/images/lead-capture/cynthia-f.png";
import bradF from "../../assets/images/lead-capture/brad-f.png";
import samB from "../../assets/images/lead-capture/sam-b.png";
import { useTranslation } from 'react-i18next';
import { Carousel } from 'react-responsive-carousel';

export interface ReviewsProps {

}

const COMPONENT_CLASS = "c-assessment-results";

const Reviews: React.FunctionComponent<ReviewsProps> = () => {
    const { t } = useTranslation();

    const reviews = [
        {
            details: t('assessmentResults.reviews.review0_details'),
            author: t('assessmentResults.reviews.review0_author'),
            profession: t('pages.leadCaptureResults.reviews.clientUser'),
            img: donU,
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_1_details'),
            author: t('pages.leadCaptureResults.reviews.review_1_author'),
            profession: t('pages.leadCaptureResults.reviews.personalTrainer'),
            img: samB
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_6_details'),
            author: t('pages.leadCaptureResults.reviews.review_6_author'),
            profession: t('pages.leadCaptureResults.reviews.strengthCoach'),
            img: jimmyM
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_3_details'),
            author: t('pages.leadCaptureResults.reviews.review_3_author'),
            profession: t('pages.leadCaptureResults.reviews.physicalTherapist'),
            img: bradF
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_4_details'),
            author: t('pages.leadCaptureResults.reviews.review_4_author'),
            profession: t('pages.leadCaptureResults.reviews.personalTrainer'),
            img: cynthiaF
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_8_details'),
            author: t('pages.leadCaptureResults.reviews.review_8_author'),
            profession: t('pages.leadCaptureResults.reviews.medGym'),
            img: davidD
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_7_details'),
            author: t('pages.leadCaptureResults.reviews.review_7_author'),
            profession: t('pages.leadCaptureResults.reviews.conditioning'),
            img: lucasM
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_2_details'),
            author: t('pages.leadCaptureResults.reviews.review_2_author'),
            profession: t('pages.leadCaptureResults.reviews.virginia'),
            img: jeffL
        },
        {
            details: t('pages.leadCaptureResults.reviews.review_5_details'),
            author: t('pages.leadCaptureResults.reviews.review_5_author'),
            profession: t('pages.leadCaptureResults.reviews.physicalTherapist'),
            img: mikeE
        },
    ];

    return (
        <>
            <div className="flex flex-wrap gap-6 justify-center hide-on-mobile">
                {reviews.map((review) =>
                    <div className={`${COMPONENT_CLASS}__review`}>
                        <div>
                            <StarIcon sx={{ color: "#43B5F8" }} />
                            <StarIcon sx={{ color: "#43B5F8" }} />
                            <StarIcon sx={{ color: "#43B5F8" }} />
                            <StarIcon sx={{ color: "#43B5F8" }} />
                            <StarIcon sx={{ color: "#43B5F8" }} />
                        </div>
                        <p>
                            "{review.details}"
                        </p>
                        <div className="flex items-center gap-2">
                            <div>
                                <img className="max-w-10" src={review.img} alt="" />
                            </div>
                            <p style={{ fontSize: "12px", lineHeight: "18px" }}>
                                <b>{review.author}</b>
                                <br />
                                {review.profession}
                            </p>
                        </div>
                    </div>
                )}
            </div>

            <div className="md:hidden">
                <Carousel showArrows={true} showStatus={false}>
                    {reviews.map((review) =>
                        <div className={`${COMPONENT_CLASS}__review`}>
                            <div>
                                <StarIcon sx={{ color: "#43B5F8" }} />
                                <StarIcon sx={{ color: "#43B5F8" }} />
                                <StarIcon sx={{ color: "#43B5F8" }} />
                                <StarIcon sx={{ color: "#43B5F8" }} />
                                <StarIcon sx={{ color: "#43B5F8" }} />
                            </div>
                            <p>
                                "{review.details}"
                            </p>
                            <div className="flex items-center gap-2">
                                <div>
                                    <img className="max-w-10" src={review.img} alt="" />
                                </div>
                                <p style={{ fontSize: "12px", lineHeight: "18px" }}>
                                    <b>{review.author}</b>
                                    <br />
                                    {review.profession}
                                </p>
                            </div>
                        </div>
                    )}
                </Carousel>
            </div>
        </>
    );
};

export default Reviews;